import { isVersionedUrl } from './is-versioned-url';

export function getCacheSetting(url: string) {
    return isVersionedUrl(url) ? undefined : 'no-store';
}
